import { WASTE_EXCHANGE_TYPE } from "../../../../domain/WasteExchangeType";

/**
 * Maps weighbridgeTickets form payload to API request format.
 * @param {Array} weighbridgeTickets - tickets from form payload
 * @param {Object} options
 * @param {boolean} [options.forceProtocolCompleted] - if true, isProtocolCompleted will be forced to true
 *        when isProtocolNeeded is true (used in management view)
 */
export function mapWeighbridgeTicketsPayload(weighbridgeTickets, { forceProtocolCompleted } = {}) {
  return (weighbridgeTickets ?? []).map((ticket) => ({
    ticketId: ticket.ticketId || null,
    ticketNumber: ticket.ticketNumber,
    netMass: parseFloat(ticket.netMass),
    remarks: ticket.remarks,
    isLoading: ticket.exchangeType === WASTE_EXCHANGE_TYPE.LOADING,
    usedContainerId: ticket.exchangeType === WASTE_EXCHANGE_TYPE.CONTAINER_EXCHANGE
      ? ticket.usedContainer?.usedContainerId
      : null,
    wasteDetails: ticket.wastes?.map((x) => ({
      id: x.id,
      wasteId: x.wasteId,
      wasteKindId: x.wasteKindId || null,
      wasteMass: parseFloat(x.wasteMass),
      wasteFormType: x.wasteFormType,
      externalWeighedWasteId: x.externalWeighedWasteId?.toString(),
      isQuickWeighed: x.isQuickWeighed
    })) ?? [],
    rejectedWasteDetails: ticket.rejectedWastes?.map((x) => ({
      id: x.id,
      weightDifferenceId: x.weightDifference?.weightDifferenceId,
      wasteMass: parseFloat(x.wasteMass),
    })) ?? [],
    isProtocolNeeded: forceProtocolCompleted && ticket.isProtocolNeeded ? false : ticket.isProtocolNeeded,
    isProtocolCompleted: forceProtocolCompleted && ticket.isProtocolNeeded ? true : ticket.isProtocolCompleted,
    externalTicketId: ticket.externalTicketId?.toString(),
    externalData: ticket.externalData ? {
      dateWeighFirst: ticket.externalData.dateWeighFirst,
      dateWeighSecond: ticket.externalData.dateWeighSecond,
      weightFirst: ticket.externalData.weightFirst,
      weightSecond: ticket.externalData.weightSecond,
      weightNet: ticket.externalData.weightNet,
      contractorId: ticket.externalData.contractorId,
      contractorName: ticket.externalData.contractorName,
      driverId: ticket.externalData.driverId,
      driverName: ticket.externalData.driverName,
      vehicleId: ticket.externalData.vehicleId,
      vehicleRegistrationNumber: ticket.externalData.vehicleRegistrationNumber,
      remarks: ticket.externalData.remarks,
      wastes: ticket.externalData.wastes?.map((w) => ({
        externalWeighedWasteId: w.externalWeighedWasteId,
        wasteCode: w.wasteCode,
        weightNet: w.weightNet
      })) ?? [],
    } : null,
    isZeroWeighedTicket: ticket.isZeroWeighedTicket
  }));
}
